import classNames from '../_util/classNames';
import { filterEmpty } from '../_util/props-util';
export function getInputClassName({ prefixCls, bordered, size, disabled, direction, condition, resize, }) {
    return classNames(prefixCls, {
        [`${prefixCls}-xs`]: size === 'extra-small',
        [`${prefixCls}-sm`]: size === 'small',
        [`${prefixCls}-bg`]: size === 'big',
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-borderless`]: !bordered || condition,
        [`${prefixCls}-condition`]: condition,
        [`${prefixCls}-resize`]: resize,
    });
}
const isValid = (value) => {
    return (value !== undefined &&
        value !== null &&
        (Array.isArray(value) ? filterEmpty(value).length : true));
};
export function hasPrefixSuffix(propsAndSlots) {
    return (isValid(propsAndSlots.prefix) ||
        isValid(propsAndSlots.suffix) ||
        isValid(propsAndSlots.allowClear) ||
        isValid(propsAndSlots.condition));
}
export function hasAddon(propsAndSlots) {
    return isValid(propsAndSlots.addonBefore) || isValid(propsAndSlots.addonAfter);
}
